import React from 'react';
import { I18n } from '@aws-amplify/core';
import styled from 'styled-components';
import { useNioshConclusion } from '@/hooks/useNioshConclusion';

const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

const CriticalList = styled.ul`
	display: flex;
	justify-content: space-between;
`;

const CriticalItem = styled.li`
	flex: 1;
	margin-inline: 10px;
`;

export function Conclusion({ formattedReport }) {
	const criticalFactors = formattedReport.critical_factors;
	// converts decimal separator to locale setting
	criticalFactors.map((factor) => {
		if (typeof factor.value === 'string') return factor;
		factor.value = parseFloat(factor.value).toLocaleString();
		return factor;
	});

	const { text, conclusion } = useNioshConclusion({
		mass_m: formattedReport.mass_m,
		lifting_index: formattedReport.lifting_index,
		recommended_weight_limit: formattedReport.recommended_weight_limit,
		risk: formattedReport.risk
	});

	return (
		<Container>
			<p style={{ marginInline: '16px' }}>
				{text.map((conclusion_text) => I18n.get(conclusion_text))}
				<strong>{I18n.get(conclusion)}</strong>
			</p>
			{formattedReport.risk !== 'LOW' && (
				<>
					<p style={{ marginInline: '16px' }}>
						{I18n.get(
							'The most critical variables are listed below with suggestions:'
						)}
					</p>
					<CriticalList>
						{criticalFactors.map((factor) => (
							<CriticalItem key={factor.label}>
								<strong>
									{I18n.get(factor.title)}{' '}
									<span style={{ color: 'darkred' }}>[{factor.value}]</span>
								</strong>
								<p style={{ marginBottom: 0 }}>
									{I18n.get(factor.suggestion)}
								</p>
							</CriticalItem>
						))}
					</CriticalList>
				</>
			)}
		</Container>
	);
}
